import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { QActivity, QButton, QDivider, QFlex, QStack, QText, useCurrentUser } from '@qualio/ui-components';
import { FormApprovalReviewComment } from '../../../types';

type EventFormViewCommentsProps = {
  comments: FormApprovalReviewComment[];
};

export const EventFormViewComments: React.FC<EventFormViewCommentsProps> = ({ comments }) => {
  const { t } = useTranslation();
  const { formatDate } = useCurrentUser();
  const [newestFirst, setNewestFirst] = useState(true);
  const [orderedComments, setOrderedComments] = useState(comments);
  const orderButtonIconText = newestFirst ? t('common.placeholders.newestFirst') : t('common.placeholders.oldestFirst');
  const orderButtonIconName = newestFirst ? 'ArrowDown' : 'ArrowUp';

  const handleCommentSortClick = useCallback(() => {
    setNewestFirst(!newestFirst);
    const reversedComments = orderedComments.reverse();
    setOrderedComments([...reversedComments]);
  }, [newestFirst, orderedComments]);

  return (
    <QFlex justifyContent="center" alignItems="center">
      <QStack direction="column" spacing="40px" width="640px">
        <QDivider />
        <QFlex alignItems="center" justify="space-between">
          <QText weight="semibold">{t('common.labels.comments')}</QText>
          <QButton variant="link" rightIcon={orderButtonIconName} onClick={handleCommentSortClick}>
            {orderButtonIconText}
          </QButton>
        </QFlex>
        <QStack direction="column" spacing="40px" width="640px" data-cy="form-comments">
          {orderedComments.map((comment) => (
            <QActivity
              key={`${comment.commentTimeStamp}-${comment.userFullName}`}
              status={comment.status}
              fullName={comment.userFullName}
              actionTimestamp={formatDate(new Date(comment.commentTimeStamp * 1000), true)}
            >
              <QText color="gray.900" fontSize="sm" fontWeight="400">
                {comment.comment}
              </QText>
            </QActivity>
          ))}
        </QStack>
      </QStack>
    </QFlex>
  );
};
